import React, { useState, useEffect } from 'react'
import './selectPaymentOption.css'
import pay_amt1 from 'assets/selectPayment-image/pay_amt1.png'
import pay_amt2 from 'assets/selectPayment-image/pay_amt2.png'
import pay_amt3 from 'assets/selectPayment-image/pay_amt3.png'
import upi from 'assets/selectPayment-image/upi.png'
import { useLocation, useNavigate } from 'react-router-dom'

const SelectPaymentOption = () => {

  const location = useLocation();
  const navigate = useNavigate();

  const { packageId, billing_amount } = location.state || {};

  const [activeMethod, setActiveMethod] = useState('credit'); 

  const handleClickPayment = (e) => {
    e.preventDefault();
    navigate('/payment-success');
  };

  const handleClick = (method) => {
    setActiveMethod(method);
  };
  const handleUpiSubmit = (e) => {
    e.preventDefault();
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className='selectPayment-container'>
      <div className='selectPaymentForm-container'>
        <h1>Register your account with us, it's free</h1>
        <div className="selectPayment-header-img">
          <img src={pay_amt1} alt="" />
          <div className="selectPayment-lines">
            <div className="line line-1"></div>
          </div>
          <img src={pay_amt2} alt="" />
          <div className="selectPayment-lines">
            <div className="line line-2"></div>
          </div>
          <img src={pay_amt3} alt="" />
        </div>
        <h6>Checkout</h6>
        <h4>Your total payable amount :  &#8377; {billing_amount} (Inc. GST)</h4>
        {activeMethod === 'credit' && (
          <form className='Payment-registration-form'>
            <div className='form-row-pay three-column'>
              <div className='pay-input-wrapper'>
                <div className={`button-row ${activeMethod === 'credit' ? 'active' : ''}`}>
                  <i className="fa-solid fa-credit-card"></i>
                  <button type='button' className='credit-card' onClick={() => handleClick('credit')}>Credit Card</button>
                  <input type='checkbox' className='checkbox-round' checked={true} />
                </div>
                <div className={`button-row ${activeMethod === 'debit' ? 'active' : ''}`}>
                  <i className="fa-solid fa-credit-card"></i>
                  <button type='button' className='credit-card' onClick={() => handleClick('debit')}>Debit Card</button>
                  <input type='checkbox' className='checkbox-round' checked={true} />
                </div>
                <div className={`button-row ${activeMethod === 'upi' ? 'active' : ''}`}>
                  <img src={upi} alt="" />
                  <button type='button' className='credit-card' onClick={() => handleClick('upi')}>UPI</button>
                  <input type='checkbox' className='checkbox-round' checked={true} />
                </div>
              </div>
            </div>
            <div className='form-row-pay two-column'>
              <div>
                <label htmlFor="card_holder_name">Name On Card:</label>
                <input type='text' placeholder='Harvy Olson' name='card_holder_name' />
              </div>
              <div>
                <label htmlFor="card_number">Card Number:</label>
                <div className='visa-wrapper'>
                  <input type='text' placeholder='3787-3449-3626-0712' name='card_number' />
                  <i className="fab fa-cc-visa icon"></i>
                </div>
              </div>
            </div>
            <div className='form-row-pay two-column'>
              <div>
                <label htmlFor="valid_date">Valid On:</label>
                <input type='date' placeholder='12/09/2024' name='valid_date' />
              </div>
              <div>
                <label htmlFor="ccv_number">CCV Code:</label>
                <input type='password' placeholder='***' name='ccv_number' />
              </div>
            </div>
            <div className='form-row-pay two-column-accept'>
              <input className='accept-team' type='checkbox' name='accept' />
              <p>Securely save this card for a faster checkout next time</p>
            </div>
            <button className='selectPayment-Pay-btn' onClick={handleClickPayment}>Pay</button>
          </form>
          
          
        )}
        {activeMethod === 'upi' && (
          <form className='Payment-registration-form' onSubmit={handleUpiSubmit}>
            <div className='form-row-pay three-column'>
              <div className='pay-input-wrapper'>
                <div className={`button-row ${activeMethod === 'credit' ? 'active' : ''}`}>
                  <i className="fa-solid fa-credit-card"></i>
                  <button type='button' className='credit-card' onClick={() => handleClick('credit')}>Credit Card</button>
                  <input type='checkbox' className='checkbox-round' checked={true} />
                </div>
                <div className={`button-row ${activeMethod === 'debit' ? 'active' : ''}`}>
                  <i className="fa-solid fa-credit-card"></i>
                  <button type='button' className='credit-card' onClick={() => handleClick('debit')}>Debit Card</button>
                  <input type='checkbox' className='checkbox-round' checked={true} />
                </div>
                <div className={`button-row ${activeMethod === 'upi' ? 'active' : ''}`}>
                  <img src={upi} alt="" />
                  <button type='button' className='credit-card' onClick={() => handleClick('upi')}>UPI</button>
                  <input type='checkbox' className='checkbox-round' checked={true} />
                </div>
              </div>
            </div>
            <div className='form-row-upi'>
              <label htmlFor="upi_id">Enter UPI ID:</label>
              <input type='text' placeholder='yourupi@bank' name='upi_id' />
            </div>
            <button className='selectPayment-Pay-btn' onClick={handleClickPayment}>Pay</button>
          </form>
        )}

        {/* Render the credit/debit form only when Credit or Debit is selected */}
        {(activeMethod === 'debit') && (
          <form className='Payment-registration-form'>
            <div className='form-row-pay three-column'>
              <div className='pay-input-wrapper'>
                <div className={`button-row ${activeMethod === 'credit' ? 'active' : ''}`}>
                  <i className="fa-solid fa-credit-card"></i>
                  <button type='button' className='credit-card' onClick={() => handleClick('credit')}>Credit Card</button>
                  <input type='checkbox' className='checkbox-round' checked={true} />
                </div>
                <div className={`button-row ${activeMethod === 'debit' ? 'active' : ''}`}>
                  <i className="fa-solid fa-credit-card"></i>
                  <button type='button' className='credit-card' onClick={() => handleClick('debit')}>Debit Card</button>
                  <input type='checkbox' className='checkbox-round' checked={true} />
                </div>
                <div className={`button-row ${activeMethod === 'upi' ? 'active' : ''}`}>
                  <img src={upi} alt="" />
                  <button type='button' className='credit-card' onClick={() => handleClick('upi')}>UPI</button>
                  <input type='checkbox' className='checkbox-round' checked={true} />
                </div>
              </div>
            </div>
            <div className='form-row-pay two-column'>
              <div>
                <label htmlFor="card_holder_name">Name On Card:</label>
                <input type='text' placeholder='Harvy Olson' name='card_holder_name' />
              </div>
              <div>
                <label htmlFor="card_number">Card Number:</label>
                <div className='visa-wrapper'>
                  <input type='text' placeholder='3787-3449-3626-0712' name='card_number' />
                  <i className="fab fa-cc-visa icon"></i>
                </div>
              </div>
            </div>
            <div className='form-row-pay two-column'>
              <div>
                <label htmlFor="valid_date">Valid On:</label>
                <input type='date' placeholder='12/09/2024' name='valid_date' />
              </div>
              <div>
                <label htmlFor="ccv_number">CCV Code:</label>
                <input type='password' placeholder='***' name='ccv_number' />
              </div>
            </div>
            <div className='form-row-pay two-column-accept'>
              <input className='accept-team' type='checkbox' name='accept' />
              <p>Securely save this card for a faster checkout next time</p>
            </div>
            <button className='selectPayment-Pay-btn' onClick={handleClickPayment}>Pay</button>
          </form>
        )}
      </div>
    </div>
  );
};

export default SelectPaymentOption
